import { configureStore } from '@reduxjs/toolkit';
import { createEpicMiddleware } from 'redux-observable';
import { rootEpic } from './rootEpic';
import rootReducer from './rootReducer';

const epicMiddleware = createEpicMiddleware();

const store = configureStore({
    reducer: rootReducer,
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            //serializableCheck: false
            immutableCheck: false,
            serializableCheck: false,
        }).concat(epicMiddleware),
    devTools: process.env.NODE_ENV === 'development',
});

epicMiddleware.run(rootEpic);

export default store;
export type RootState = ReturnType<typeof store.getState>;
